<div class="mat-subtitle-2 zwi-sermon-category-row__title"><ng-content></ng-content></div>
